var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"dashboard-image"},[_c(_vm.image,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }